<template>
  <BDataTable
    :client="ordersClient"
    :defaultFilter="{ status: 'completed,open' }"
    :showFooter="true"
  >
    <template v-slot:filter>
      <BFilterCheckbox name="status" :options="options" label="Status"></BFilterCheckbox>
    </template>

    <template v-slot:actions>
      <div>
        <basic-button
          v-if="$route.params.organizer == 28523 && showButton"
          @click="$router.push({ name: 'orders.create', query: { event_id: event } })"
          size="sm"
          leading-icon="plus"
        >
          Bestellung anlegen
          <span class="bg-gray-600 rounded px-1 text-xs uppercase ml-2">Beta</span>
        </basic-button>
      </div>
    </template>

    <template v-slot:header>
      <div
        class="px-4 py-2 hidden md:grid grid-cols-12 grid-flow-col text-sm uppercase font-medium bg-gray-50 border-b border-gray-200"
      >
        <div class="col-span-4">Beschreibung</div>
        <div class="col-span-3">Datum</div>
        <div class="col-span-3">Veranstaltung</div>
        <div class="col-span-2">Status</div>
      </div>
    </template>

    <template v-slot:table="{ item }">
      <router-link
        :to="{ name: 'orders.order', params: { id: item.id } }"
        class="px-4 py-2 grid grid-cols-12 items-center border-b border-gray-200 hover:bg-gray-50"
      >
        <div class="mr-4 col-span-7 md:col-span-4 truncate">
          <span class="font-medium">{{ item.first_name }} {{ item.last_name }}</span>
          <span v-show="item.first_name || item.last_name" class="mx-1">&middot;</span>
          <span class>{{ item.id }}</span>
        </div>
        <div class="col-span-12 sm:col-span-7 md:col-span-3">
          <span class="text-gray-700">{{ formatDateTimeForHuman(item.created_at.local) }} Uhr</span>
        </div>
        <div class="hidden sm:block col-span-5 md:col-span-2 truncate">{{ item.event.title }}</div>
        <div
          class="ml-auto col-span-5 col-start-8 row-start-1 md:ml-0 md:col-span-2 md:col-start-11"
        >
          <order-status-badge
            class="px-1 sm:px-4 text-xs sm:text-sm uppercase"
            :status="item.status"
          ></order-status-badge>
        </div>
      </router-link>
    </template>
  </BDataTable>
</template>

<script>
import { BDataTable, BFilterCheckbox } from '@/components/BDataTable';
import ordersClient from '@/api/central/orders';
import OrderStatusBadge from '@/components/OrderStatusBadge';
import InteractsWithDates from '@/mixins/InteractsWithDates';

export default {
  components: {
    BDataTable,
    BFilterCheckbox,
    OrderStatusBadge,
  },
  props: {
    showButton: {
      default: false,
    },
    event: {
      default: '',
      required: false,
    },
  },
  mixins: [InteractsWithDates],
  data() {
    return {
      options: [
        {
          value: 'completed',
          label: 'Erfolgreich',
        },
        {
          value: 'open',
          label: 'Offen',
        },
        {
          value: 'refunded',
          label: 'Rückerstattet',
        },
        {
          value: 'partially_refunded',
          label: 'Teilweise Rückerstattet',
        },
        {
          value: 'cancelled',
          label: 'Abgebrochen',
        },
      ],
    };
  },

  methods: {
    ordersClient({ page, resolve, filter }) {
      return ordersClient
        .index({ page, ...filter, event: this.event ? this.event : '' })
        .then(({ data }) => {
          resolve(data);
        });
    },
  },
};
</script>